export default __webpack_public_path__ + "39179e0f5a4df83b4554a1306cb7aba2.png";